import preval from 'preval.macro'
import { NullableString } from './Types';

const buildEpoch = preval`module.exports = new Date().valueOf();`
const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';


const routes = {
    start: "/",
    startLogin: "/?login=y",
    // Simple
    simple_profile: "/profile",
    simple_app_tools: "/tools",
    simple_ads: "/ads",
    simple_ads_plant: "/ads/plants",
    simple_campaigns: "/campaigns",
    simple_assortment: "/assortment",
    simple_assortment_edit: "/assortment/edit",
    simple_insights: "/insights",
    simple_billing: "/billing",

    // Pro
    pro_home: "/pro",
    pro_plants: "/pro/plants",
    pro_tests: "/pro/tests",
    pro_accounts: "/pro/accounts",
    pro_account: "/pro/account/:id",
    pro_getAccountDetail: (id: string) => "/pro/account/" + id,
    pro_subscription: "/pro/account/subscription",

    // Planner
    planner_home: "/planner",
    planner_projects: "/planner/projects",
    planner_editProject: "/planner/projects/:id/edit",
    planner_getEditProject: (id: string) => "/planner/projects/" + id + "/edit",

    // 

}


// Server
const devUrl = "https://localhost:44310";
const prodUrl = "https://api.ohgarden.se";
const serverUrl = (() => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        return devUrl;
    } else {
        return prodUrl;
    }
})();

export const Config = {
    serverUrl: serverUrl,
    buildEpoch: isDev ? 0 : buildEpoch,
    routes: routes,
    isDev: isDev,
    //
    appData_HelloEmail: "hello@ohgarden.se",
    appData_SupportEmail: "support@ohgarden.se",
    appData_AddressFirstLine: "Björkviksvägen 24",
    appData_AddressSecondLine: "185 94 Vaxholm",
    appData_FacebookLink: "https://www.facebook.com/ohgardenstories",
    appData_InstagramLink: "https://www.instagram.com/ohgardenstories",
    appData_AppStoreLink: "https://apps.apple.com/se/app/oh-garden/id1580037492",
    appData_PlayStoreLink: "https://play.google.com/store/apps/details?id=se.ohgarden.app",
    appData_LoginLinkNoToken: "https://share.ohgarden.se/handletoken/",
    appData_GetPOlabtLink: (plantId: NullableString) => "https://share.ohgarden.se/plant/" + plantId + "?iframe=true",
    appData_NumberOfPlantsCount: 25000,
}
